module.exports = __webpack_public_path__ + "static/img/banner.7235d1eb.png";